import { Component, OnInit } from '@angular/core';

import {UserCreationService} from '../../shared/user-creation.service';
import { UserCreation } from '../../shared/user-creation.model';

@Component({
  selector: 'app-customer-creation',
  templateUrl: './customer-creation.component.html',
  styleUrls: ['./customer-creation.component.css']
})
export class CustomerCreationComponent implements OnInit {

  butDisabled: boolean = true;

  title = "Customer Creation";

  selectedUser: UserCreation;
  
  constructor( private userCreation:UserCreationService) { }

  ngOnInit() {
  }
      //fuc(){
      //debugger;
      //}
}



// WEBPACK FOOTER //
// ./src/app/masters/customer-creation/customer-creation.component.ts